import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center gap-3" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = { class: "w-12 text-center font-bold text-gray-900 bg-gray-100 rounded-lg px-3 py-2 text-lg" };
const _hoisted_4 = ["disabled"];
import { computed } from 'vue';
import { useTheme } from '@shared/composables/useTheme';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuantitySelector',
    props: {
        quantity: {},
        isAvailable: { type: Boolean }
    },
    emits: ["increase", "decrease"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { theme } = useTheme();
        const dangerButtonStyle = computed(() => ({
            backgroundColor: theme.value.colors.danger,
            opacity: '0.9'
        }));
        const successButtonStyle = computed(() => ({
            backgroundColor: theme.value.colors.success,
            opacity: '0.9'
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('decrease'))),
                    disabled: _ctx.quantity <= 1 || !_ctx.isAvailable,
                    class: "w-10 h-10 text-white rounded-full flex items-center justify-center transition-all duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed",
                    style: _normalizeStyle(dangerButtonStyle.value)
                }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "fas fa-minus text-sm" }, null, -1 /* CACHED */)
                    ]))], 12 /* STYLE, PROPS */, _hoisted_2),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.quantity), 1 /* TEXT */),
                _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event) => (emit('increase'))),
                    disabled: !_ctx.isAvailable,
                    class: "w-10 h-10 text-white rounded-full flex items-center justify-center transition-all duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed",
                    style: _normalizeStyle(successButtonStyle.value)
                }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fas fa-plus text-sm" }, null, -1 /* CACHED */)
                    ]))], 12 /* STYLE, PROPS */, _hoisted_4)
            ]));
        };
    }
});
